<div class="activity-container threaddetail-sidesheet-status"
    [ngClass]="{'container-empty': noDataStyle === 'flex'&&windowSize<695}">
    <div class="body-header" *ngIf="config.data.isContactActivity">
        <div class="title body-header-title">Activities</div>
        <div class="body-header-icon">
            <smart-icon class="angle-icon" name="meatball" (click)="onMeatball($event,$event)"></smart-icon>
        </div>
    </div>
    <div class="body-container">
        <div class="panel-tab">
            <tam-tab-set [selectedIndex]="selectedIndex" (selectChange)="selectChange($event)" [draggable]="false">
                <tam-tab *ngFor="let item of menuItems;trackBy:trackByFn" [title]="item" [disabled]="false"
                    [editable]="false" [editing]="false"></tam-tab>
            </tam-tab-set>
        </div>
        <div class="panel-content">
            <div class="data-container screen-loading-spin" loading-spin [isLoading]="isPageLoading"
                [loadingSize]="'small'">
                <div class="no-data" [style.display]="noDataStyle">
                    <span>No Data</span>
                </div>
                <div *ngFor="let item of activityItems;trackBy:trackByFn">
                    <div class="item-title" *ngIf="item.value.length !== 0">{{item.title}}</div>
                    <div *ngFor="let subItem of item.value;trackBy:trackByFn" class="item-content">
                        <div class="subItem">
                            <div class="subItem-left">
                                <div *ngIf="subItem.value.itemType === 'Event'" class="event-icon">E</div>
                                <div *ngIf="subItem.value.itemType === 'Note'" class="note-icon">N</div>
                                <div *ngIf="subItem.value.itemType === 'Task'" class="task-icon">T</div>
                                <div *ngIf="subItem.value.itemType === 'Task' && subItem.value.priority === 2"
                                    class="high-priority">!</div>
                                <div (click)="onItemClick($event,subItem)" class="active-span"
                                    [title]="subItem.value.value">
                                    {{subItem.value.value}}</div>
                            </div>
                            <div class="subItem-right body-3" [ngClass]="{'invalid-text': subItem.value.isInvalid }">
                                {{subItem.title}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <context-menu #contextItemMenu *ngIf="config.data.isContactActivity">
        <ng-template contextMenuItem let-item (execute)="onMenuSelect($event)">
            <div class="screen-menu-item-container">
                <span class="context-menu-title">Relationships</span>
            </div>
        </ng-template>

        <ng-template contextMenuItem let-item [subMenu]="screenSubMenu">
            <div class="screen-menu-item-container">
                <span class="context-menu-title">Contact Profile</span>
            </div>
            <smart-icon name="angle-right" class="angle-right">
            </smart-icon>
        </ng-template>
        <context-menu #screenSubMenu>
            <ng-template contextMenuItem *ngFor="let subMenu of contextMenu;trackBy:trackByFn"
                (execute)="onMenuSelect($event)">
                <div class="screen-sub-menu-container">
                    <span>{{subMenu.title}}</span>
                </div>
            </ng-template>
        </context-menu>

        <ng-template *ngIf="config.position !== 2 && config.position !== 4 && !isCollapse" contextMenuItem let-item
            (execute)="onMenuSelect($event)">
            <div class="screen-menu-item-container">
                <span class="context-menu-title">Collapse Tile</span>
            </div>
        </ng-template>
        <ng-template *ngIf="config.position !== 2 && config.position !== 4 && isCollapse" contextMenuItem let-item
            (execute)="onMenuSelect($event)">
            <div class="screen-menu-item-container">
                <span class="context-menu-title">Expand Tile</span>
            </div>
        </ng-template>
    </context-menu>
</div>